import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('meta.about_title')}</title>
        <meta name="description" content="Learn about Karni Digital Solutions, your trusted digital partner in Pattaya, Thailand." />
      </Helmet>

      <section className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4" data-aos="fade-up">
              {t('about.title')}
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="200">
              {t('about.mission')}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div data-aos="fade-right">
              <h2 className="text-3xl font-bold text-primary mb-6">Our Story</h2>
              <p className="text-gray-600 mb-6">
                {t('about.story')}
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                    <span className="text-primary font-bold">✓</span>
                  </div>
                  <span className="text-gray-800 font-medium">{t('about.local_expertise')}</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                    <span className="text-primary font-bold">✓</span>
                  </div>
                  <span className="text-gray-800 font-medium">{t('about.multilingual')}</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                    <span className="text-primary font-bold">✓</span>
                  </div>
                  <span className="text-gray-800 font-medium">{t('about.proven_results')}</span>
                </div>
              </div>
            </div>
            
            <div data-aos="fade-left">
              <div className="bg-gradient-primary p-8 rounded-xl text-white">
                <h3 className="text-2xl font-bold mb-6 text-gold">{t('about.why_trust')}</h3>
                <div className="space-y-4">
                  <div className="bg-white bg-opacity-10 p-4 rounded-lg">
                    <h4 className="font-semibold mb-2">250+ Successful Projects</h4>
                    <p className="text-sm">Delivered exceptional results across various industries</p>
                  </div>
                  <div className="bg-white bg-opacity-10 p-4 rounded-lg">
                    <h4 className="font-semibold mb-2">10+ Years Experience</h4>
                    <p className="text-sm">Deep expertise in digital transformation</p>
                  </div>
                  <div className="bg-white bg-opacity-10 p-4 rounded-lg">
                    <h4 className="font-semibold mb-2">6 Languages Support</h4>
                    <p className="text-sm">Serving diverse international community in Pattaya</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
